exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GIS_Client #mapstore-login-panel {\r\n    width: 300px;\r\n}\r\n.GIS_Client #mapstore-login-panel button {\r\n    float: right !important;\r\n}\r\n", ""]);

// exports
